import { useState, useEffect } from "react";
import { Modal, Input, Upload, Button, Image, message } from "antd";
import { UploadOutlined, DeleteOutlined } from "@ant-design/icons";
import { getImg } from "../../../Api/getImg";
import { useResponsive } from "./EditColumnModal";

const EditCellModal = ({
  open,
  onClose,
  onUpdate,
  editingCell,
  updatingCell
}) => {
  const { isMobile } = useResponsive();
  const [text, setText] = useState("");
  const [photoFile, setPhotoFile] = useState(null);
  const [removeImage, setRemoveImage] = useState(false);
  const [previewUrl, setPreviewUrl] = useState(null);

  useEffect(() => {
    if (editingCell) {
      setText(editingCell.text || "");
      setPhotoFile(null);
      setRemoveImage(false);
      setPreviewUrl(editingCell.photoId ? getImg(editingCell.photoId) : null);
    }
  }, [editingCell]);

  const handleFileChange = (file) => {
    setPhotoFile(file);
    setRemoveImage(false);
    
    // Create preview URL
    const reader = new FileReader();
    reader.onloadend = () => {
      setPreviewUrl(reader.result);
    };
    reader.readAsDataURL(file);
    
    return false; // Prevent auto upload
  };

  const handleRemoveImage = () => {
    setPhotoFile(null);
    setRemoveImage(true);
    setPreviewUrl(null);
  };

  const handleUpdate = () => {
    if (!text.trim() && !photoFile && !editingCell?.photoId) {
      message.warning("Please add some content or upload an image");
      return;
    }

    onUpdate({
      bookingId: editingCell.bookingId,
      columnId: editingCell.columnId,
      text: text.trim(),
      photoFile: removeImage ? null : photoFile
    });
  };

  return (
    <Modal
      title={<span className={isMobile ? 'text-base' : ''}>Edit Cell Content</span>}
      open={open}
      onCancel={onClose}
      onOk={handleUpdate}
      confirmLoading={updatingCell}
      width={isMobile ? '95vw' : 600}
      okText="Update"
      cancelText="Cancel"
      okButtonProps={{ 
        style: { backgroundColor: '#298E9F' }
      }}
      centered={isMobile}
    >
      <div className={`space-y-${isMobile ? '3' : '4'}`}>
        {/* Text Input */}
        <div>
          <label className={`block font-semibold text-gray-700 mb-2 ${isMobile ? 'text-xs' : 'text-sm'}`}>
            Notes
          </label>
          <Input.TextArea
            placeholder="Enter notes or observations..."
            value={text}
            onChange={(e) => setText(e.target.value)}
            rows={isMobile ? 4 : 6}
            className="w-full"
            size={isMobile ? 'middle' : 'large'}
          />
        </div>

        {/* Image Section */}
        <div>
          <label className={`block font-semibold text-gray-700 mb-2 ${isMobile ? 'text-xs' : 'text-sm'}`}>
            Image
          </label>
          
          {previewUrl && !removeImage ? (
            <div className="relative inline-block">
              <Image
                src={previewUrl}
                alt="Preview"
                width={isMobile ? 150 : 200}
                height={isMobile ? 150 : 200}
                className="rounded-lg object-cover"
                preview
              />
              <Button
                type="primary"
                danger
                icon={<DeleteOutlined />}
                onClick={handleRemoveImage}
                className="absolute top-2 right-2"
                size="small"
              />
            </div>
          ) : (
            <Upload
              beforeUpload={handleFileChange}
              maxCount={1}
              accept="image/*"
              listType="picture-card"
              showUploadList={false}
            >
              <div className={`text-center ${isMobile ? 'p-2' : ''}`}>
                <UploadOutlined style={{ fontSize: isMobile ? 20 : 24 }} />
                <div className={`mt-2 ${isMobile ? 'text-xs' : ''}`}>
                  {isMobile ? 'Upload' : 'Upload Image'}
                </div>
              </div>
            </Upload>
          )}
        </div>
      </div>
    </Modal>
  );
};

export default EditCellModal;